module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.aff8b511.svg";